import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons/faEnvelope";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {ToastService} from "../../../shared/utilities/services/ToastService";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";

let createColumn=require('../../../../../js/formBuilder/sfAnalytics').CreateColumn;

export class ResendDialog extends DynamicDialog<ColumnDialogProps,ColumnDialogState> {
    static defaultProps: Partial<ColumnDialogProps> = {};
    public SelectedEmail:any=0;
    public IsBusy:boolean=false;
    constructor(props: ColumnDialogProps) {
        super(props);
        this.state = {
            IsOpen:true
        };
    }



    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Resend selected email',
            IsOpen:this.state.IsOpen,
            Icon:<FontAwesomeIcon icon={faEnvelope}/>,
            EnableApply:true,
            EnableCancel:false,
            ApplyTitle:'Resend',
            IsBusy:this.IsBusy,
            OnApply:()=>{this.Send()}
        };
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div>
                <SearchableSelect onChange={e=>{this.SelectedEmail=e;this.forceUpdate();}} Value={this.SelectedEmail}>
                    {this.props.Form.ServerOptions.Emails.map((x,index)=>
                        <option key={index.toString()} value={index.toString()}>{x.Name}</option>
                    )}
                </SearchableSelect>
            </div>
        );
    }

    private async Send() {
        let selectedEmail=this.props.Form.ServerOptions.Emails[this.SelectedEmail];
        if(selectedEmail==null)
            ToastService.SendErrorMessage('Please select an email');

        this.IsBusy=true;
        this.forceUpdate();
        let result=await WpAjaxPost.Post('rednao_smart_forms_resend_email',{EmailIndex:this.SelectedEmail,Form:this.props.Form.FormId,EntryId:this.props.EntryId});
        if(result!=null)
        {
            this.SendResult(true);
            this.setState({IsOpen:false})
            ToastService.SendSuccess('Email send successfully')
        }

        this.IsBusy=false;
        this.forceUpdate();
    }
}



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ColumnDialogProps {
    Form:any;
    EntryId:any;
}

interface ColumnDialogState extends DynamicDialogState{

}

//#endregion "My Region"